import axios from "axios";

const normalizeBase = (b) => String(b || "").trim().replace(/\/+$/, "");
const API_BASE = normalizeBase(import.meta.env.VITE_API_BASE_URL || "");

async function request(path, params = {}, options = {}) {
  const response = await axios.get(`${API_BASE}${path}`, {
    params: {
      ...params,
      _ts: Date.now(),
    },
    timeout: 45000,
    validateStatus: (status) => status >= 200 && status < 500,
    signal: options.signal,
  });

  if (response.status >= 400) {
    throw new Error(response?.data?.message || response?.data?.error || `Erro HTTP ${response.status}`);
  }

  const payload = response.data || {};
  if (payload.ok === false) {
    throw new Error(payload.message || "Erro ao buscar Mercos");
  }

  return payload.data ?? payload;
}

export async function fetchMercosVisitas({ base, de, ate, vendedorId } = {}, options = {}) {
  return request("/api/mercos/visitas", { base, de, ate, vendedorId }, options);
}

export async function fetchMercosAtendimentos({ base, de, ate, vendedorId } = {}, options = {}) {
  return request("/api/mercos/atendimentos", { base, de, ate, vendedorId }, options);
}
